module.exports = __webpack_public_path__ + "media/images/panels/panel-4-top-qualitaet-d04c6b180bec9f32bf624362a56d16aa.jpg";